import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from '../context/FormContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronLeft, FiChevronRight } = FiIcons;

function StepLayout({ 
  title, 
  subtitle, 
  children, 
  stepNumber, 
  totalSteps, 
  nextButtonText = 'Next',
  prevButtonText = 'Previous',
  nextStep, 
  prevStep,
  onNext,
  onPrev
}) {
  const navigate = useNavigate();
  const { validateStep, setErrors } = useForm();

  const handleNext = () => {
    if (onNext) {
      onNext();
      return;
    }

    // Validate current step
    const errors = validateStep(stepNumber);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      // Show validation errors but allow progression
      const errorMessages = Object.values(errors).join(', ');
      console.log('Validation errors:', errorMessages);
    }

    if (nextStep) {
      navigate(`/step/${nextStep}`);
      // Scroll to top after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const handlePrev = () => {
    if (onPrev) {
      onPrev();
      return;
    }

    if (prevStep) {
      navigate(`/step/${prevStep}`);
      // Scroll to top after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <div className="form-container bg-white rounded-xl shadow-lg p-6 md:p-8 mx-auto">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h1 className="step-heading text-2xl md:text-3xl font-bold text-gray-900">{title}</h1>
          </div>
          <span className="text-base text-gray-500 bg-gray-100 px-3 py-1 rounded-full ml-4">
            Step {stepNumber} of {totalSteps}
          </span>
        </div>
        {subtitle && (
          <p className="text-gray-600 text-lg">{subtitle}</p>
        )}
      </div>

      {/* Content */}
      <div className="mb-8">
        {children}
      </div>

      {/* Navigation */}
      <div className="flex justify-between items-center pt-6 border-t border-gray-200">
        {prevStep ? (
          <button
            onClick={handlePrev}
            className="flex items-center space-x-2 px-6 py-3 border-2 border-[#FF5841] text-[#FF5841] rounded-lg hover:bg-[#FF5841] hover:text-white transition-colors duration-200 font-medium"
          >
            <SafeIcon icon={FiChevronLeft} className="h-4 w-4" />
            <span className="font-medium">Previous</span>
          </button>
        ) : (
          <div></div>
        )}

        {nextStep && stepNumber !== 7 && (
          <button
            onClick={handleNext}
            className="flex items-center space-x-2 px-8 py-3 bg-[#FF5841] text-white rounded-lg hover:bg-[#E5503A] transition-colors duration-200 font-medium"
          >
            <span>{nextButtonText}</span>
            <SafeIcon icon={FiChevronRight} className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}

export default StepLayout;